import React from 'react';

import ScreenLoader from '../../components/ScreenLoader';

export default ({loading, children}: any) => {
  return loading ? <ScreenLoader spinnerSize="lg" containerHeight="500px" /> : children;
};
